import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { WineryStoryResponse, WineryStoryUpdatePayload } from '@shared/partner-ui/models/winery-story';
import { WineryStoryApi } from '@shared/partner-ui/services/winery-story-api';

@Injectable({
  providedIn: 'root'
})
export class WineryStoryService implements WineryStoryApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  async fetchStory(_wineryId?: string): Promise<WineryStoryResponse> {
    return firstValueFrom(
      this.http.get<WineryStoryResponse>(`${this.baseUrl}/winery-story`, { withCredentials: true })
    );
  }

  async updateStory(payload: WineryStoryUpdatePayload, _wineryId?: string): Promise<WineryStoryResponse> {
    return firstValueFrom(
      this.http.put<WineryStoryResponse>(`${this.baseUrl}/winery-story`, payload, { withCredentials: true })
    );
  }
}
